import { Fragment, MouseEvent } from 'react'
import { isNil } from 'lodash'

import { Group } from 'lib/_types'
import { useGroupActions, useInfinityScrollSimple } from 'hooks'
import { useCurrentUser } from 'store/api/yay/user'
import { useGetGroupMutateMutation } from 'store/api/yay/group'

import LoadMore from '../LoadMore'
import { GroupItem } from './GroupItem'

type Props = Omit<GroupItem, 'index' | 'group' | 'userId' | 'onClick'> & {
  groups: {
    isLoading?: boolean
    data?: Array<Group>
    meta?: {
      isFullyLoaded: boolean
    }
  }
  onLoadMore?: () => void
  onGroupClick?: (group: Group, index?: number) => void
}

const GroupList = ({ groups, onLoadMore, onGroupClick, ...props }: Props) => {
  const { data: currentUser } = useCurrentUser()

  const { attemptJoinGroup, GroupActionConfirmBox } = useGroupActions()

  const [getGroupMutate] = useGetGroupMutateMutation()

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore: () => {
      onLoadMore?.()
    },
  })

  const onClick =
    (group: Group, index: number) =>
    async (e: MouseEvent<HTMLAnchorElement>) => {
      onGroupClick?.(group, index)

      if (
        group?.is_private &&
        !group?.is_joined &&
        !group?.invited_to_join &&
        group?.owner?.id != currentUser?.id
      ) {
        e.preventDefault()

        const groupRes = await getGroupMutate({
          groupId: group?.id?.toString?.(),
        })

        // `group` does not contain `guidelines`.
        attemptJoinGroup(groupRes?.['data']?.group, () => {
          window.location.reload()
        })
      }
    }

  return (
    <Fragment>
      <div className="GroupsList">
        {groups?.data?.map?.((group, index) => (
          <GroupItem
            key={group?.id}
            index={index}
            group={group}
            userId={currentUser?.id}
            onClick={onClick}
            {...props}
          />
        ))}

        <LoadMore
          isLoading={groups?.isLoading}
          ref={loadMoreRef}
          onClick={onLoadMore}
          hidden={groups?.meta?.isFullyLoaded || isNil(onLoadMore)} // No load more from sidebar.
        />
      </div>

      <GroupActionConfirmBox />
    </Fragment>
  )
}

export default GroupList
